export default {
  init() {
    // JavaScript to be fired on the draw pages
    $(document).ready(function () {
      $('div#wpsl-stores .title-search-wrap').css('margin-bottom', '10px').append('<input id="title-search" placeholder="Filter by vendor name">')

      $('#wpsl-search-input').on('change', function () {
        $('#title-search').val('').trigger('input')
      })
      $('#wpsl-search-btn').on('click', function () {
        $('#title-search').val('').trigger('input')
      })

      $('#title-search').on('input', function (e) {
        e.preventDefault()
        let titleValue = $(this).val().toLowerCase()
        $('#wpsl-result-list ul li').each(function() {
          let vendorTitle = $(this).find('strong').text().toLowerCase()
          if(vendorTitle.indexOf(titleValue) != -1) {
            $(this).show()
          } else {
            $(this).hide()
          }
        })

      })

    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/internalBloodDrawLocator.js